module.exports = __webpack_public_path__ + "static/img/tree_planting.fe29b161.svg";